<template>
  <div style="padding:20px;">
    <el-row>
      <el-col :span="24">
        <el-button
            style="padding: 0; margin: 20px"
            type="text"
            icon="el-icon-back"
            @click="backPrePage()"
        >
          返回
        </el-button>
      </el-col>
    </el-row>
    <el-row :gutter="20">
      <el-form ref="form" :model="form" label-width="150px" :disabled="formLoading">
        <el-row>
          <el-col :span="24">
            <el-form-item label="秒杀ID" prop="id">
              <el-input
                  v-model="form.target_id"
                  maxlength="30"
                  show-word-limit
                  style="width:33%"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <el-form-item>
          <el-button type="primary" :loading="onSaveLoading" @click="onSave">保存</el-button>
          <el-button @click="backPrePage()">取消</el-button>
        </el-form-item>
      </el-form>
    </el-row>
  </div>
</template>
<script>
import {
  getItemInfo, updateFlashSaleInfo
} from "@/api/mall";

export default {
  data: function () {
    return {
      id: '',
      info: {},
      form: {
        target_id: '',
        module_id: '',
      },
      ossAction: "",
      formLoading: false,
      onSaveLoading: false,
    }
  },
  created: function () {
    this.id = this.$route.query.id;
    this.form.module_id = this.$route.query.module_id;
    if (this.id != 0) {
      this.getInfo();
    }else{
      this.form.id = 0;
    }
  },
  methods: {
    getInfo() {
      this.formLoading = true;
      getItemInfo({
        id: this.id
      }).then(response => {
        this.formLoading = false
        this.form = response.data
      });
    },
    uploadSuccess(value) {
      this.form[value.formName] = value.fileUrl
    },
    onSave() {
      this.onSaveLoading = true;
      let that = this
      updateFlashSaleInfo(this.form).then(res => {
        that.onSaveLoading = false;
        if (res.code == 1) {
          that.$message({
            showClose: true,
            duration: 6000,
            message: '保存成功',
            type: 'success'
          });
          that.backPrePage();
        }
      });

    },
    backPrePage() {
      this.$router.go(-1);
    }
  },
}
</script>
<style>
.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}

.avatar-uploader .el-upload:hover {
  border-color: #409EFF;
}

.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 100px;
  min-height: 70px;
  line-height: 70px;
  text-align: center;
}

.avatar {
  width: 100px;
  min-height: 40px;
  display: block;
}
</style>